module.exports = __webpack_public_path__ + "static/media/manual1.a4ba6ecb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/manual1.pdf
// module id = 768
// module chunks = 0